"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubscriptionSettingsSchema = void 0;
const mystake_common_sdk_1 = require("@redbelly-tokeniser/mystake-common-sdk");
const yup = __importStar(require("yup"));
const ALLOW_SUBSCRIPTIONS_REQUIRED = "Please select whether investors may subscribe";
const DEALING_FREQUENCY_REQUIRED = "Please select a dealing frequency";
const CUSTOM_DATES_REQUIRED = "Please enter at least one custom dealing date";
const CUSTOM_DATES_TOO_MANY = `A maximum of ${mystake_common_sdk_1.MAX_CUSTOM_DEALING_DATES} custom dealing dates can be configured`;
const CUSTOM_DATE_INVALID = "Please enter a valid custom dealing date";
const CUSTOM_DATES_DUPLICATE = "Each custom dealing date must fall on a different day";
const CUTOFF_REQUIRED = "Please enter an end of day";
const CUTOFF_WEEKDAY_INVALID = "End-of-day weekday must be 1 (Monday) to 5 (Friday)";
const CUTOFF_TIME_INVALID = "End-of-day time must be a 24-hour time in the format 14:00";
const CUTOFF_TIMEZONE_INVALID = "Please select a valid timezone, e.g. Australia/Sydney";
const MINIMUM_SUBSCRIPTION_INVALID = "Minimum subscription must be a whole number of units, and cannot be negative";
const MAXIMUM_SUBSCRIPTION_INVALID = "Maximum subscription must be a whole number of at least one unit";
const MAXIMUM_BELOW_MINIMUM = "Maximum subscription cannot be below the minimum subscription";
const ROUNDING_METHOD_REQUIRED = "Please select a rounding method";
const roundingMethodValues = Object.values(mystake_common_sdk_1.RoundingMethod);
// Values arrive as ISO strings, and `new Date()` maps `null`, `0` and `false` onto the epoch. Junk is
// dropped here and reported by the per-item date rule.
const toDealingDates = (value) => {
    if (!Array.isArray(value)) {
        return [];
    }
    return value
        .map((entry) => {
        if (!(entry instanceof Date) && typeof entry !== "string") {
            return null;
        }
        const parsed = entry instanceof Date ? entry : new Date(entry);
        return Number.isFinite(parsed.getTime()) ? parsed : null;
    })
        .filter((entry) => entry !== null);
};
// Falls back to `undefined` (the runtime zone) when the end-of-day cannot supply one; the end-of-day
// rules already report that case.
const fundTimezone = (cutoff) => {
    const timezone = cutoff?.timezone;
    return (0, mystake_common_sdk_1.isSupportedTimezone)(timezone) ? timezone : undefined;
};
// Counted in the fund's zone, not the server's: two timestamps six hours apart are one dealing day in
// Sydney and two in UTC, so a server-local count would call two distinct dealing days a duplicate.
const dealingDays = (dates, timezone) => [...new Set(dates.map((date) => (0, mystake_common_sdk_1.dealingDayKey)(date, timezone)))].sort();
exports.SubscriptionSettingsSchema = yup.object().shape({
    allowSubscriptions: yup.boolean().required(ALLOW_SUBSCRIPTIONS_REQUIRED),
    dealingFrequency: yup
        .string()
        .trim(DEALING_FREQUENCY_REQUIRED)
        .required(DEALING_FREQUENCY_REQUIRED)
        .oneOf(Object.values(mystake_common_sdk_1.DealingFrequency), DEALING_FREQUENCY_REQUIRED),
    customDealingDates: yup.array().when("dealingFrequency", {
        is: mystake_common_sdk_1.DealingFrequency.CUSTOM,
        then: (schema) => schema
            .of(yup.date().typeError(CUSTOM_DATE_INVALID).required(CUSTOM_DATE_INVALID))
            .min(1, CUSTOM_DATES_REQUIRED)
            .max(mystake_common_sdk_1.MAX_CUSTOM_DEALING_DATES, CUSTOM_DATES_TOO_MANY)
            .required(CUSTOM_DATES_REQUIRED)
            .test("unique-dealing-days", CUSTOM_DATES_DUPLICATE, (value, context) => {
            const dates = toDealingDates(value);
            return dealingDays(dates, fundTimezone(context.parent?.cutoff)).length === dates.length;
        }),
        otherwise: (schema) => schema.nullable().notRequired(),
    }),
    cutoff: yup
        .object({
        weekday: yup
            .number()
            .typeError(CUTOFF_WEEKDAY_INVALID)
            .required(CUTOFF_WEEKDAY_INVALID)
            .integer(CUTOFF_WEEKDAY_INVALID)
            .min(1, CUTOFF_WEEKDAY_INVALID)
            // Business days only: a window closes on the business day before its dealing date, so a weekend
            // end-of-day describes a moment that never arrives.
            .max(5, CUTOFF_WEEKDAY_INVALID),
        time: yup.string().required(CUTOFF_TIME_INVALID).matches(mystake_common_sdk_1.REDEMPTION_CUTOFF_TIME_PATTERN, CUTOFF_TIME_INVALID),
        timezone: yup
            .string()
            .required(CUTOFF_TIMEZONE_INVALID)
            .test("supported-timezone", CUTOFF_TIMEZONE_INVALID, (value) => (0, mystake_common_sdk_1.isSupportedTimezone)(value)),
    })
        // Without this a missing `cutoff` defaults to `{}` and slips past `required`, reporting three
        // inner-field errors instead of the one that names what is missing.
        .default(undefined)
        .required(CUTOFF_REQUIRED),
    minimumSubscriptionUnits: yup
        .number()
        .typeError(MINIMUM_SUBSCRIPTION_INVALID)
        .required(MINIMUM_SUBSCRIPTION_INVALID)
        .integer(MINIMUM_SUBSCRIPTION_INVALID)
        .min(0, MINIMUM_SUBSCRIPTION_INVALID),
    maximumSubscriptionUnits: yup
        .number()
        .typeError(MAXIMUM_SUBSCRIPTION_INVALID)
        .required(MAXIMUM_SUBSCRIPTION_INVALID)
        .integer(MAXIMUM_SUBSCRIPTION_INVALID)
        // Not `.min(0)`: a ceiling of zero satisfies no application, and the completeness gate rejects it.
        .min(1, MAXIMUM_SUBSCRIPTION_INVALID)
        .test("at-or-above-minimum", MAXIMUM_BELOW_MINIMUM, (value, context) => {
        const minimum = context.parent?.minimumSubscriptionUnits;
        return typeof value !== "number" || typeof minimum !== "number" || value >= minimum;
    }),
    roundingMethod: yup
        .string()
        .trim(ROUNDING_METHOD_REQUIRED)
        .required(ROUNDING_METHOD_REQUIRED)
        .oneOf(roundingMethodValues, ROUNDING_METHOD_REQUIRED),
});
//# sourceMappingURL=SubscriptionSettingsSchema.js.map